import React from 'react';
import './table.css';

interface StatusCellProps {
  status: string;
  statusMap: Record<
    string,
    {
      label: string;
      dotClass?: string;
    }
  >;
  className?: string;
}

const StatusCell: React.FC<StatusCellProps> = ({ status, statusMap, className = 'table-cell-centered' }) => {
  const statusInfo = statusMap[status] || { label: 'Неизвестно' };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {statusInfo.dotClass !== undefined && (
        <span className={`status-dot ${statusInfo.dotClass ? `status-dot-${statusInfo.dotClass}` : ''}`}></span>
      )}
      <span>{statusInfo.label}</span>
    </div>
  );
};

export default StatusCell;
